import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from 'vue-demi';
import useGsap from '../../../../composables/useGsap';
import { CdnImg } from '@webplatform/cdn-image';
import UiModal from '../../../lorgar/ui/UiModal.vue';
import {
  AbDescription,
  AbTitle,
  AbSection,
  AbContainer,
  AbButton,
  AbIcon,
  AbLink,
} from '../../../ui';
import MainHeroAnimatedBackground from '../../../lorgar/ui/MainHeroAnimatedBackground.vue';
import { Spacing } from '../../../../helpers/shared-props';

interface Props {
  id?: string | null;
  image: {
    alt?: string | null;
    src: string;
  };
  link: {
    src?: string | null;
    text: string;
  };
  title?: string | null;
  description?: string | null;
  modal?: {
    title?: string | null;
    description?: string | null;
    files: {
      name: string;
      src: string;
    }[];
  } | null;
  spacing?: Spacing | null;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'HeroSection',
  props: {
    id: null,
    image: null,
    link: null,
    title: null,
    description: null,
    modal: null,
    spacing: null
  },
  setup(__props: any) {


const modalRef = ref();
const heroSection = ref();
const imageElement = ref();
const textElement = ref();
const { gsap, ScrollTrigger } = useGsap();

const animateOnScroll = () => {
  if (gsap && ScrollTrigger) {
    const instance = gsap.matchMedia();
    instance.add('(min-width: 1024px)', () => {
      gsap.fromTo(
        textElement.value,
        {
          y: 0,
        },
        {
          y: -50,
          ease: 'power3.out',
          scrollTrigger: {
            scrub: 1,
            trigger: heroSection.value.$el,
            start: 'top top',
            end: '40% 200px',
            toggleActions: 'restart none none reverse',
          },
        },
      );

      gsap.fromTo(
        imageElement.value,
        {
          y: 0,
        },
        {
          y: 50,
          ease: 'power3.out',
          scrollTrigger: {
            scrub: 1,
            trigger: heroSection.value.$el,
            start: '-95 top',
            end: 'bottom 200px',
            toggleActions: 'restart none none reverse',
          },
        },
      );
    });

    instance.add('(max-width: 1023px)', () => {
      gsap.fromTo(
        textElement.value,
        {
          y: 0,
        },
        {
          y: -20,
          ease: 'power3.out',
          scrollTrigger: {
            scrub: 1,
            trigger: heroSection.value.$el,
            start: 'top top',
            end: '50% 200px',
            toggleActions: 'restart none none reverse',
          },
        },
      );
      gsap.fromTo(
        imageElement.value,
        {
          y: 0,
        },
        {
          y: 50,
          ease: 'power3.out',
          scrollTrigger: {
            scrub: 1,
            trigger: heroSection.value.$el,
            start: 'top top',
            end: 'bottom 200px',
            toggleActions: 'restart none none reverse',
          },
        },
      );
    });
  }
};

onMounted(() => {
  animateOnScroll();
});

const openModal = () => {
  modalRef.value.open();
};

return { __sfc: true,modalRef, heroSection, imageElement, textElement, gsap, ScrollTrigger, animateOnScroll, openModal, CdnImg, UiModal, AbDescription, AbTitle, AbSection, AbContainer, AbButton, AbIcon, AbLink, MainHeroAnimatedBackground }
}

})